import { TitlePage } from 'components/atoms'
import { InputField, InputSelectOptions } from 'components/molecules'
import { GENDER, CUSTOMER_TYPE, VERIFICATION_METHOD } from 'domains/user/constants'
import { CustomInput } from 'reactstrap'
import PropTypes from 'prop-types'
import { ToggleField } from 'components'
import ReferrerInputField from './referrer-input-field'

const propTypes  = {
  formikBag: PropTypes.object
}
const UserFields = ({ formikBag }) => (
  <>
    <TitlePage mainTitle={ 'User Profile' } />

    <InputField
      type='text'
      name='name'
      label='Name'
      placeholder='Mariana'
      required={ true }
    />
    <InputField
      type='text'
      name='email'
      label='Email'
      placeholder='mariana@gmail.com'
      required={ true }
    />
    <InputField
      type='tel'
      name='mobile'
      label='Phone Number'
      placeholder='62821xxxxxx'
      required={ true }
    />
    <InputField
      type='date'
      name='birthday'
      label='Birthday'
      required={ true }
    />

    <InputField
      type='select'
      name='gender'
      label='Gender'
      required={ true }
    >
      <InputSelectOptions options={ GENDER } keyPrefix={ 'gender' } />
    </InputField>

    <ReferrerInputField
      name='sign_up_affiliate_name'
      label='Referrer'
      required={ true }
    />

    <InputField
      type='select'
      name='customer_type'
      label='Customer Type'
      required={ true }
    >
      <InputSelectOptions options={ CUSTOMER_TYPE } keyPrefix={ 'cutomer_type' } />
    </InputField>

    <ToggleField
      className='mb-2'
      id='verification_method'
      name='is_verified'
      label={ 'Verification Method' }
      required={ false }
      formText={ <>
        <strong>Yes: </strong>User does not need to go through OTP verification
        <br />
        <strong>No: </strong>User need to go through OTP verification
      </> }
    />
    <CustomInput
      id='verification_method'
      type='select'
      name='verification_method'
      required={ false }
      onChange={ (e) => formikBag.setFieldValue('verification_method', e.target.value) }
      disabled={ !formikBag.values.is_verified }
      invalid={ formikBag.errors.verification_method == 'Required' && formikBag.touched.verification_method }
    >
      <InputSelectOptions options={ VERIFICATION_METHOD } keyPrefix={ 'verification_method' } />
    </CustomInput>

  </>
)

UserFields.propTypes = propTypes

export default UserFields
